// import { useEffect, useState } from 'react'

import { ShowMoreHeight } from './ShowMoreHeight/ShowMoreHeight'

import { MainSectionText } from './MainSectionText/MainSectionText'
import { MainSectionHTML } from './MainSectionHTML/MainSectionHTML'
import NewMessageReplyForm from './NewMessageReplyForm'
import { MessageAttachmentsSection } from './MessageAttachmentsSection/MessageAttachmentsSection'

import './CardMainSection.sass'

import { parseUrlsToLinksInsideText } from '@/app-domains/threads/api/serializers'

export function CardMainSection (props) {
  const { thread } = props
  // const [thread, setThread] = useState(props.thread)
  const message = thread.messages.filter((message) => message.isHeadOfThread)[0]

  const canTextBeParsedAsHTML = !message.html && parseUrlsToLinksInsideText(message.text).length > message.text.length
  
  // eslint-disable-next-line
  const htmlContent = message.html || (canTextBeParsedAsHTML ? parseUrlsToLinksInsideText(message.text) : undefined)

  return (
    <section className="CardMainSection">
      <ShowMoreHeight height="250" message={message} thread={thread}>
        {
          htmlContent
            ? <MainSectionHTML html={htmlContent}/>
            : <MainSectionText text={message.text}/>
        }
      </ShowMoreHeight>
      <MessageAttachmentsSection attachments={message.attachments} />
      { thread?.messages.length <= 1 && message.repliable && <NewMessageReplyForm thread={thread} message={message}/> }
    </section>
  )
}
export default CardMainSection
